<template>
    <va-edit-layout>
        <ShipmentEventOrderFee-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventOrderFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
